<template>
  <div drop-select :class="{ opened, open, error, readonly, dark }" @click="toggle">
    <a class="btn" :style="{ 'min-width': dropWidth }">
      <s v-html="selected && ( selected.label || selected )"/>
    </a>
    <div class="drop-select-wrapper" :style="{ height: dropHeight, 'min-width': dropWidth }" @transitionend="animated">
      <div class="scroll-body" :class="variant">
        <ul>
          <li ontouchstart="" class="item" :class="{on: value === ''}" @click="change(getFallback(), true)" v-if="useBlank"><s v-html="placeholder"/></li>
          <li ontouchstart="" class="item" :class="{on: (item.value === undefined ? item : item.value) === value}" v-for="item in listCreated" :key="item.value === undefined ? item : (item.value + item.label)" @click="change(item, true)"><s v-html="item.label || item"/></li>
          <li ontouchstart="" class="item" :class="{on: value === key}" v-for="(label, key) in obj" :key="key + label" @click="change({label, value: key}, true)"><s v-html="label" /></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="less">
  @import "~@/less/proj";

  [drop-select] { .pointer; .rel; .ib; .fs(16); .semi-bold; color: #222;
    .btn { .block; .wf; .tl; .p(13,54,13,20); .fs(18); .lh(28); .bgc(#fff); .rel; .-box; .calibre;
      s { .cal-m; }
      &:after{ .cnt; .block; .abs; .rt(13,13); .wh(28,28); .bg-contain('@{common}/filter-black.svg');}
    }
    .drop-select-wrapper { .bgc(#fff); .-box; overflow: hidden; height: 0; transition: opacity 0.1s 0.2s, height 0.3s; .abs; .lt(0, 100%); z-index: 100; .-box; opacity: 0; .wf;
      .scroll-body { .max-h(50vh); .lb; overflow: auto; .abs; min-width: 100%; }
      ul { .mb(0);
        li { .p(8, 20); .fs(18); .calibre;
          &:first-child { .pt(26); }
          &:last-child { .pb(26); }
        }
      }
    }
    &.open {
      .btn { .br-t(2);
        &:after{ .bg-contain('@{common}/filter-close.png');}
      }
      .drop-select-wrapper { opacity: 1; transition: opacity 0.1s, height 0.3s; .br-b(2); .-t(#e0e0e0); }
    }
    &.readonly {
      label { .bgc(#eee); }
    }
    &.opened {
      .drop-select-wrapper {  }
    }
    &.dark { color: #e0e0e0;
      .btn { .bgc(#2c3036); .medium;
        &:after{ .bg-contain('@{common}/filter-w.svg');}
      }
      .drop-select-wrapper { .bgc(#2c3036); .regular; }
      &.open {
        .btn { .br-t(2);
          &:after{ .bg-contain('@{common}/close-white.svg');}
        }
        .drop-select-wrapper { .-t(rgba(224,224,224,0.1)); }
      }
    }
  }

  @media (min-width: @screen-lg-min) {
    [drop-select] {
      .drop-select-wrapper {
      }
    }
  }

</style>
<!--suppress JSUnresolvedFunction -->
<script>
import _ from 'lodash';
import { isTouch } from '@/utils';

export default {
  name: 'DropSelect',
  props: {
    value: { default: null },
    list: { type: Array, default: null },
    split: { type: String, default: null },
    obj: { default: null },
    placeholder: { type: String, default: null },
    mandatory: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    useBlank: { type: Boolean, default: false },
    variant: { type: String, default: 'outline-info' },
    dark: { type: Boolean, default: false },
  },
  data() {
    return {
      open: false,
      opened: false,
      selected: null,
      dropHeight: 0,
      dropWidth: 0,
      fallbackValue: null,
    };
  },
  mounted() {
    this.update(true);
  },
  watch: {
    list: 'update',
    obj: 'update',
    value: 'update',
  },
  computed: {
    down() {
      return isTouch() ? 'touchstart' : 'mousedown';
    },
    listCreated() {
      return this.split ? this.split.split(/[ ]*,[ ]*/) : this.list;
    },
    error() {
      return this.mandatory && (this.selected === null || (typeof this.selected === 'object' && !this.selected.value && this.selected.value !== 0) || !this.selected);
    },
  },
  methods: {
    closeCheck(event) {
      let { target } = event;
      while (target) {
        if (target === this.$el) return;
        target = target.parentNode;
      }
      this.close();
    },
    openSelect() {
      this.open = true;
      this.opened = true;
      const scrollBody = this.$el.querySelector('.scroll-body');
      const scrollContent = this.$el.querySelector('.scroll-body > ul');
      const selectedItem = scrollBody.querySelector('li.on');
      if (selectedItem) {
        scrollBody.scrollTop = selectedItem.offsetTop;
      }
      this.dropHeight = `${scrollBody.offsetHeight}px`;
      this.dropWidth = `${scrollContent.offsetWidth}px`;
      window.addEventListener(this.down, this.closeCheck);
      window.addEventListener('resize', this.closeCheck);
      window.addEventListener('scroll', this.closeCheck);
    },
    close() {
      this.open = false;
      this.dropHeight = 0;
      this.dropWidth = 0;
      window.removeEventListener(this.down, this.closeCheck);
      window.removeEventListener('resize', this.closeCheck);
      window.removeEventListener('scroll', this.closeCheck);
    },
    animated() {
      this.opened = this.open;
    },
    toggle() {
      if (!this.open) {
        this.openSelect();
      } else {
        this.close();
      }
    },
    change(val, artificial) {
      if (this.selected === val || (this.selected && this.selected.value !== undefined && this.selected.value === val.value)) return;
      this.selected = val;
      const v = !val || val.value === undefined ? val : val.value;
      this.$emit('input', v);
      if (artificial) this.$emit('change', v);
    },
    getFallback() {
      if (!this.fallbackValue) this.fallbackValue = { value: '', label: this.placeholder };
      return this.fallbackValue;
    },
    update() {
      let val;
      if (this.listCreated) {
        val = _.find(this.listCreated, item => (item.value || item) === this.value);
      } else if (this.obj) {
        val = this.obj[this.value] ? { label: this.obj[this.value], value: this.value } : null;
      }
      if (!val) {
        if (this.placeholder) {
          val = this.getFallback();
        } else if (this.listCreated) {
          [val] = this.listCreated;
        } else if (this.obj) {
          _.forEach(this.obj, (label, value) => {
            if (!val) val = { label, value };
          });
        }
      }
      this.change(val);
    },
  },
};
</script>
